import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface HospitalDashIdeaProjectProps {
    hospitalDashData: any
}

const HospitalDashIdeaProject: FC<HospitalDashIdeaProjectProps> = ({ hospitalDashData }) => {
    return (
        <div className='flex flex-col gap-6 md:gap-12 pt-6 md:pt-12 bg-darkGreyPrimary'>
            {hospitalDashData.HosDashIdeaProjectsData.map((projects: any, index: number) => {
                 let img = getImage(projects.image ?? "") ?? "";

                return (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: index * 0.2 }}
                        className='bg-darkGreyPrimary py-6 md:py-12 border-b-4 border-[#313131] last:border-0'
                    >
                        <div className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} px-4 md:px-40 gap-6 md:gap-10 justify-center`}>
                            <motion.div
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                                className={classNames('flex flex-col w-full md:w-2/4 pl-2 md:pl-6')}
                            >
                                <div className={classNames('font-semibold text-2xl md:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                                <div className={classNames('text-greyQuaternary text-base md:text-lg pt-1 pb-4 md:pb-10', `text-${projects.text}`)}>{projects.subtitle}</div>
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 justify-between`}>
                                    {projects.steps.map((project: any, idx: number) => {
                                        return (
                                            <motion.div
                                                key={idx}
                                                initial={{ opacity: 0, scale: 0.9 }}
                                                whileInView={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.4, delay: idx * 0.1 }}
                                                className="relative bg-blackDark text-white px-4 md:px-6 py-3 md:py-4 rounded-lg shadow-lg"
                                            >
                                                <div className={`absolute top-0 left-0 w-3 md:w-4 h-3 md:h-4 bg-${projects.textColor} rounded-tl-lg rounded-br-3xl`}></div>
                                                <p className="text-base md:text-lg font-medium">{project.title}</p>
                                            </motion.div>
                                        )
                                    })}
                                </div>
                            </motion.div>
                            <motion.div
                                initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                                className={`mt-6 md:mt-0 bg-blackDark border border-${projects.textColor} w-full md:w-2/6 h-auto p-2 md:p-4`}
                            >
                                {/* <img src={projects.image} className='w-full' alt={projects.title} /> */}
                                <DynamicSVG size='w-full'>{img}</DynamicSVG>
                            </motion.div>
                        </div>
                    </motion.div>
                )
            })}
        </div>
    )
}

export default HospitalDashIdeaProject